import {
  GET_ALL_LEVEL_TYPES,
  SET_LOADING_ALL_LEVEL_TYPES,
  ERROR_ALL_LEVEL_TYPES,
} from "../types";
import axiosInstance from "../request";

export function getAllLevelTypes() {
  return async function(dispatch) {
    try {
      dispatch({ type: SET_LOADING_ALL_LEVEL_TYPES });

      const res = await axiosInstance.get(`/level_types/`);
      const dataRes = res.data;

      dispatch({
        type: GET_ALL_LEVEL_TYPES,
        payload: dataRes.results,
      });
    } catch (e) {
      dispatch({
        type: ERROR_ALL_LEVEL_TYPES,
        payload: e.response,
      });
    }
  };
}
